module.exports = __webpack_public_path__ + "img/20220423_162431.be4ae8ba.jpg";